import { render, staticRenderFns } from "./view-invoice-detail.vue?vue&type=template&id=33e4e27d&scoped=true&"
import script from "./view-invoice-detail.vue?vue&type=script&lang=js&"
export * from "./view-invoice-detail.vue?vue&type=script&lang=js&"
import style0 from "./view-invoice-detail.vue?vue&type=style&index=0&id=33e4e27d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e4e27d",
  null
  
)

export default component.exports